import styled from 'styled-components';
import device from '../../../../GlobalDigitalStyle/BreakPoint.style';

export const RunningActivitiesContainer = styled.div`
	.home__headers {
		font-weight: 700;
		.header__toggle__tab {
			padding: 1.5em 2em;
			@media ${device.screen1440} {
				padding: 1.5em;
			}
			@media ${device.screen1366} {
				padding: 1.5em 1em;
			}
			@media ${device.screen1050} {
			}
		}
	}
	.activities__container {
		height: 41em;
		@media ${device.screen1680} {
			height: 37.5em;
		}
		@media ${device.screen1366} {
			height: 35.5em;
		}
		@media ${device.screen1280} {
			height: 32em;
		}
		@media ${device.screen1050} {
			height: 28em;
		}
	}
	.running__activity__container {
		padding: 2em;
		display: flex;
		flex-direction: column;
		gap: 0.7em;
		.running__Activity__header {
			.running__Activity__name {
				font-size: 17px;
				@media ${device.screen1680} {
					font-size: 16px;
				}
				@media ${device.screen1280} {
					font-size: 14.8px;
				}
				@media ${device.screen1050} {
					font-size: 13px;
				}
			}
			img {
				border: 1px solid #01abc1;
			}
		}
		.running__activity__des {
			font-weight: 500;
		}
		.running__Activity__tail {
			font-size: 17px;
			@media ${device.screen1680} {
				font-size: 16px;
			}
			@media ${device.screen1280} {
				font-size: 14.8px;
			}
			@media ${device.screen1050} {
				font-size: 13px;
			}
		}
	}
	.text__default {
		font-weight: 600;
		font-size: 15px;
		@media ${device.screen1680} {
			font-size: 14px;
		}
		@media ${device.screen1280} {
			font-size: 12.8px;
		}
		@media ${device.screen1050} {
			font-size: 11px;
		}
	}
`;
